/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ base: NonNullable<unknown>, days: NonNullable<unknown> }} Coach_Rationale_ImmatureInputs */

const en_coach_rationale_immature = /** @type {(inputs: Coach_Rationale_ImmatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.base} Metrics are still stabilizing (${i?.days} days of data) — plan is conservative until 4 weeks of history.`)
};

const de_coach_rationale_immature = /** @type {(inputs: Coach_Rationale_ImmatureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.base} Metriken pendeln sich noch ein (${i?.days} Tage Daten) — Plan bleibt konservativ, bis 4 Wochen Verlauf da sind.`)
};

/**
* | output |
* | --- |
* | "{base} Metrics are still stabilizing ({days} days of data) — plan is conservative until 4 weeks of history." |
*
* @param {Coach_Rationale_ImmatureInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_rationale_immature = /** @type {((inputs: Coach_Rationale_ImmatureInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Rationale_ImmatureInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_rationale_immature(inputs)
	return de_coach_rationale_immature(inputs)
});